<template>
    <div class="field">
        <label class="label">Car grade</label>
        <div class="control">
            <input v-model="carGrade" type="text" class="input" placeholder="Type car grade" />
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            carGrade: {
                get: function () {
                    return this.$store.getters.getQueryCarGrade
                },
                set: function (value) {
                    this.$store.dispatch('addNewCarGrade', value)
                }
            }
        }
    }
</script>

<style scoped>
    .field {
        margin-top: 23px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/CarGradeInput.vue